import { render, staticRenderFns } from "./ViewPersonalGoal.vue?vue&type=template&id=32916ff0"
import script from "./ViewPersonalGoal.vue?vue&type=script&lang=js"
export * from "./ViewPersonalGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports